import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CategoriesService } from '../../services/categories/categories.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-indexation',
    templateUrl: './indexation.component.html',
    styleUrl: './indexation.component.scss',
    standalone: false
})
export class IndexationComponent implements OnInit {
  indexationFormGroup: FormGroup;
  indexation: any;
  disable: boolean = false;
  measurementPage: any;

  constructor(
    private formBuilder: FormBuilder,
    private categoriesService: CategoriesService,
    public dialogRef: MatDialogRef<IndexationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  ngOnInit(): void {
    this.createForm();
    this.createFormControls();
  }

  createFormControls() {
    return this.indexationFormGroup.controls;
  }

  createForm() {
    this.indexationFormGroup = this.formBuilder.group({
      id: [this.data.indexationItem.id],
      is_default:[this.data.indexationItem.is_default],
      name: [this.data.indexationItem.name],
      description: [this.data.indexationItem.description],
      unit_cost: [this.data.indexationItem.unit_cost],
      unit_of_measurement: [this.data.indexationItem.unit_of_measurement],
      update_old_notes:[false],
    });
  }
 
  isActiveValueChanged(event) {
    this.indexationFormGroup.get(event.labelEn).setValue(event.value);
  }

  save() {
    let payload = {...this.indexationFormGroup.value, term: this.data.termId};
    this.disable = false;
    this.categoriesService.updateIndexation(payload, this.data?.indexationItem?.id).subscribe(data =>{
      this.disable = true;
      this.dialogRef.close(data); 
    })
  }
}
